(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('widgetAcumuladoChuvaPeriodo', widgetAcumuladoChuvaPeriodo);

  function widgetAcumuladoChuvaPeriodo() {
    return {
      templateUrl: 'views/widgets/acumulado-chuva-periodo/view.html',
      restrict: 'A',
      controller: 'WidgetAcumuladoChuvaPeriodoCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
  }
}());
